import Link from 'next/link';
import styled from 'styled-components';
import { Typography } from '../../../ui/Typography';
import { Breakpoints } from '../../../../styled/constants';

export const AgencyInfoLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  text-decoration: none;
  padding-bottom: 15px;
  gap: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding-bottom: 30px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 15px 0;
    pointer-events: none;
    cursor: default;
  }
`;

export const AgencyInfoContent = styled.div`
  align-self: center;
`;

export const AgencyInfoTitle = styled(Typography)`
  display: block;
  margin-bottom: 2px;
`;

export const AgencyInfoText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const AgencyInfoLogo = styled.div`
  width: 55px;
  height: 55px;
  min-width: 55px;
  min-height: 55px;
  border-radius: 100px;
  overflow: hidden;
  align-self: center;
`;
